import React from "react";
import "./FactorsToConsider.css";

const FactorsToConsider = () => {
  const features = [
    {
      title: "Professional Management",
      description:
        "A team of experts monitors & manages your investments for maximum safety.",
    },
    {
      title: "Consistent Returns Each Month",
      description:
        "Earn 8-10% profit monthly on your investments for steady financial growth.",
    },
    {
      title: "Security First",
      description:
        "Your funds are protected with bank-level encryption and strict risk management strategies.",
    },
    {
      title: "Full Transparency",
      description:
        "No hidden fees, no surprises just clear, honest, & reliable investment processes.",
    },
    {
      title: "Flexible Investment",
      description:
        "Start with as little you like & increase your investments as you grow.",
    },
    {
      title: "Easy and fast Withdrawals",
      description:
        "Withdraw your profits at the end of every month without hassle or delay.",
    },
    {
      title: "24/7 Customer Support:",
      description:
        "Our support team is always available to answer your questions & guide you.",
    },
    {
      title: "Global Invest Access:",
      description:
        "Invest in your portfolio from anywhere in the world through secure platform.",
      isHighlight: true, // Used to color the text orange as seen in the image
    },
  ];

  return (
    <section className="factors-to-consider-growboo-section">
      <div className="container">
        <div className="ftc-header">
          <h2>Factors to Consider for Investing on Grow Bizint International</h2>
          <p>
            At Grow Bizint International, we make investing simple, profitable, and
            stress-free. Our platform ensures your money is safe while
            delivering consistent returns and complete transparency.
          </p>
        </div>

        <div className="features-grid">
          {features.map((item, index) => (
            <div key={index} className="feature-card">
              <h3>{item.title}</h3>
              <p className={item.isHighlight ? "text-highlight" : ""}>
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FactorsToConsider;
